<template>
  <v-sheet
    v-if="items.length"
    class="py-10 py-md-13 py-lg-16 px-3 mx-auto"
    color="transparent"
    max-width="900px"
  >
    <div class="py-md-16">
      <CarouselWidget
        :items="items"
        :itemsToShow="itemsToShow"
        :playSpeed="6000"
        dots
      >
        <template #item="{ item }">
          <div class="position-relative item">
            <img
              class="d-flex ml-auto item-img"
              :src="files + item.img + '?resize=1&w=960'"
            />

            <v-sheet
              class="
                pa-5 pa-md-7 pa-lg-10
                mt-n10 mt-md-0
                mx-auto mx-md-0
                position-relative
                item-content
              "
              color="#f5f5f5"
              :width="contentWidget"
            >
              <div
                class="
                  primary--text
                  text--lighten-1 text-md-h6 text-center text-md-left
                  font-weight-bold
                  item-title
                "
              >
                {{ item.title }}
              </div>

              <ButtonWidget
                class="mt-4 mt-md-6"
                :to="item.to"
                :align="smAndDown ? 'center' : 'left'"
              >
                {{ btnText }}
              </ButtonWidget>
            </v-sheet>
          </div>
        </template>
      </CarouselWidget>
    </div>
  </v-sheet>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "articles",
  path: "/noticias",
};

const _pagination = {
  itemsPerPage: 3,
  returnTotalItems: 0,
};

const _data = {
  itemsToShow: {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },
  btnText: "Leia Mais",
};

export default {
  data: () => ({
    ..._data,
  }),
  created() {
    this.getList();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, introduction }) => ({
          img,
          title,
          introduction,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    contentWidget() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
          return "45%";

        case "sm":
          return "90%";

        default:
          return "95%";
      }
    },
  },
  methods: {
    getList() {
      const params = {
        ..._pagination,
      };

      this.$rest(_config.mod).get({ params });
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    CarouselWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 4 / 3;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: top;
    width: 70%;

    @media screen and (max-width: 960px) {
      width: 100%;
    }
  }

  &-content {
    @media screen and (min-width: 960.001px) {
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    @media screen and (max-width: 960px) {
      position: relative;
    }
  }

  &-title {
    line-height: 1.3 !important;
  }

  &-text {
    line-height: 1.6 !important;
  }
}
</style>
